function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LeagueOverlayTemplate = require('./league.template');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var Leaderboard = require('./../leaderboard');
var LeagueWelcome = require('./league-welcome');
var JoinLeagueOverlay = require('./join');
var InvitationLink = require('./../../../../lib/saito/ui/modals/saito-link/saito-link');
var LeagueOverlay = /*#__PURE__*/function () {
  function LeagueOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, LeagueOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.league = null;
    this.leaderboards = {};
    app.connection.on('league-overlay-render-request', function (league_id, game_name) {
      var view = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'home';
      if (league_id) {
        _this.league = _this.mod.returnLeague(league_id);
      } else if (game_name) {
        var ls = _this.mod.returnLeaguesByGame(game_name);
        if (ls.length > 0) {
          _this.league = ls[0];
        }
      }
      if (_this.league) {
        _this.render();
        _this.changeViewTab(view);
      } else {
        console.warn('Overlay Render Request for Invalid League');
      }
    });
    app.connection.on('league-overlay-remove-request', function () {
      _this.overlay.remove();
    });
  }

  // --------------------------------------------
  // Do not directly call render -- emit an event
  // --------------------------------------------
  return _createClass(LeagueOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var game_mod, obj;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this.league) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              // So we keep a kopy of the league - leaderboard for faster clicking
              if (!this.leaderboards[this.league.id]) {
                this.leaderboards[this.league.id] = new Leaderboard(this.app, this.mod, '.league-overlay-leaderboard', this.league);
              }
              this.overlay.show(LeagueOverlayTemplate(this.app, this.mod, this.league));
              game_mod = this.app.modules.returnModuleByName(this.league.game);
              if (game_mod) {
                this.overlay.setBackground(game_mod.respondTo('arcade-games').image);
              }

              //Show Leaderboard
              this.leaderboards[this.league.id].render();

              //Show list of recent games (once refreshed)
              _context.n = 2;
              return this.app.modules.renderInto('.league-overlay-games-list');
            case 2:
              obj = {
                game: this.league.game
              };
              if (this.league.admin) {
                obj['league_id'] = this.league.id;
              }
              this.app.connection.emit('league-overlay-games-list', obj);

              //Add click event to create game
              this.attachEvents();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (document.getElementById('league-overlay-create-game-button')) {
        document.getElementById('league-overlay-create-game-button').onclick = function (e) {
          _this2.overlay.remove();
          if (_this2.league.admin) {
            // private leagues get league provided
            _this2.app.connection.emit('arcade-launch-game-wizard', {
              game: _this2.league.game,
              league: _this2.league
            });
          } else {
            // default games skip as invites are open
            _this2.app.connection.emit('arcade-launch-game-wizard', {
              game: _this2.league.game,
              skip: 1
            });
          }
        };
      }
      if (document.querySelector('.join_league')) {
        document.querySelector('.join_league').onclick = function () {
          var jlo = new JoinLeagueOverlay(_this2.app, _this2.mod, _this2.league.id);
          jlo.render();
        };
      }
      if (document.querySelector('.backup_account')) {
        document.querySelector('.backup_account').onclick = function () {
          _this2.app.connection.emit('saito-backup-render-request', {
            success_callback: function success_callback() {
              _this2.render();
            }
          });
        };
      }
      if (document.querySelector('.contact_admin')) {
        document.querySelector('.contact_admin').onclick = function () {
          if (!_this2.email_admin) {
            _this2.overlay.remove();
            _this2.email_admin = new LeagueWelcome(_this2.app, _this2.mod, _this2.league);
            _this2.email_admin.render();
            _this2.league.email_sent = true;
          } else {
            salert('You already messaged the league admin. Please be patient');
          }
        };
      }
      if (document.getElementById('league-chat-button')) {
        document.getElementById('league-chat-button').onclick = function () {
          var player_keys = _this2.league.players.map(function (obj) {
            return obj.publicKey;
          });
          _this2.overlay.remove();
          var league_group = {
            name: _this2.league.name,
            id: _this2.league.id,
            key: player_keys
          };
          //This will serve as a flag to create a "permanent" group
          if (_this2.league.admin === _this2.mod.publicKey) {
            league_group.admin = _this2.league.admin;
          }
          _this2.app.connection.emit('open-chat-with', league_group);
        };
      }
      if (document.getElementById('league-invite-button')) {
        document.getElementById('league-invite-button').onclick = function (e) {
          var data = {
            game: _this2.league.game,
            league_id: _this2.league.id,
            name: 'League',
            path: '/arcade/'
          };
          _this2.invitation_link = new InvitationLink(_this2.app, _this2.mod, data);
          _this2.invitation_link.render();
        };
      }
      if (!document.querySelector('.contactAdminWarning')) {
        Array.from(document.querySelectorAll('.league-page-tab')).forEach(function (item) {
          item.onclick = function (e) {
            _this2.changeViewTab(e.currentTarget.id);
          };
        });
      }
    }
  }, {
    key: "changeViewTab",
    value: function changeViewTab(nav) {
      document.querySelector('.active-tab').classList.remove('active-tab');
      document.querySelector('.league-overlay-leaderboard').classList.remove('hidden');
      document.querySelector('.league-overlay-body').classList.remove('admin-mode');
      Array.from(document.querySelectorAll('.league-overlay-body-content > .league-overlay-content-box')).forEach(function (div) {
        return div.classList.add('hidden');
      });
      switch (nav) {
        case 'home':
          document.querySelector('.league-overlay-description').classList.remove('hidden');
          break;
        case 'contact':
          document.querySelector('#admin_details').classList.remove('hidden');
          if (document.querySelector('#admin_note')) {
            document.querySelector('#admin_note').classList.remove('hidden');
          }
          break;
        case 'games':
          document.querySelector('.league-overlay-league-body-games').classList.remove('hidden');
          break;
        case 'players':
          document.querySelector('.league-overlay-body').classList.add('admin-mode');
          document.querySelector('#admin-widget').classList.remove('hidden');
          document.querySelector('.league-overlay-leaderboard').classList.add('hidden');
          this.loadPlayersUI();
          break;
        case 'rankings':
          document.querySelector('.league-overlay-leaderboard').classList.add('hidden');
      }
      document.querySelector("#".concat(nav, ".league-page-tab")).classList.add('active-tab');
    }
  }, {
    key: "loadPlayersUI",
    value: function loadPlayersUI() {
      var _this3 = this;
      this.app.browser.replaceElementById("<div id=\"admin-widget\" class=\"admin-widget league-overlay-content-box\">\n      <div class=\"saito-table\">\n        <div class=\"saito-table-header\">\n          <div>Player</div>\n          <div>Score</div>\n          <div>Games Completed</div>\n          <div>Games Started</div>\n          <div>Last Activity</div>\n          <div>Email</div>\n          <div>Remove</div>\n        </div>\n        <div class=\"saito-table-body\"></div>\n        </div>\n        </div>", 'admin-widget');
      if (!this.league) {
        return;
      }
      var html = '';
      var _iterator = _createForOfIteratorHelper(this.league.players),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var player = _step.value;
          var datetime = this.app.browser.formatDate(player.timestamp);
          html += "<div class=\"saito-table-row\">\n        <div>".concat(this.app.browser.returnAddressHTML(player.publicKey), "</div>\n        <div class=\"player_score editable_field\" data-id=\"").concat(player.publicKey, "\" contenteditable=\"true\">").concat(Math.round(player.score), "</div>\n        <div>").concat(Math.round(player.games_finished), "</div>\n        <div>").concat(Math.round(player.games_started), "</div>\n        <div>").concat(datetime.day, " ").concat(datetime.month, " ").concat(datetime.year, "</div>\n        <div class=\"email_field editable_field\" data-id=\"").concat(player.publicKey, "\" contenteditable=\"true\">").concat(player.email, "</div>\n        <div class=\"remove_player\" data-id=\"").concat(player.publicKey, "\"><i class=\"fas fa-ban\"></i></div>\n      </div> ");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.app.browser.addElementToSelector(html, '#admin-widget .saito-table-body');
      Array.from(document.querySelectorAll('.email_field')).forEach(function (player_contact) {
        player_contact.onblur = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var newtx, i;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return _this3.mod.createUpdatePlayerTransaction(_this3.league.id, e.currentTarget.dataset.id, sanitize(player_contact.textContent), 'email');
                case 1:
                  newtx = _context2.v;
                  _this3.app.network.propagateTransaction(newtx);
                  for (i = 0; i < _this3.league.players.length; i++) {
                    if (_this3.league.players[i].publicKey === e.currentTarget.dataset.id) {
                      _this3.league.players[i].email = sanitize(player_contact.textContent);
                    }
                  }
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      });
      Array.from(document.querySelectorAll('.remove_player')).forEach(function (player) {
        player.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var key, c, tx;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  key = e.currentTarget.dataset.id;
                  _context3.n = 1;
                  return sconfirm("Remove ".concat(_this3.app.keychain.returnIdentifierByPublicKey(key, true), " from the league?"));
                case 1:
                  c = _context3.v;
                  if (!c) {
                    _context3.n = 3;
                    break;
                  }
                  _context3.n = 2;
                  return _this3.mod.createQuitTransaction(_this3.league.id, key);
                case 2:
                  tx = _context3.v;
                  _this3.app.network.propagateTransaction(tx);
                  _this3.mod.removeLeaguePlayer(_this3.league.id, key);
                  _this3.app.connection.emit('remove-user-from-chat-group', _this3.league.id, key);
                  _this3.loadPlayersUI();
                case 3:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      });
      Array.from(document.querySelectorAll('.player_score')).forEach(function (player) {
        player.onblur = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var key, c, new_score, newtx, i;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  key = e.currentTarget.dataset.id;
                  _context4.n = 1;
                  return sconfirm("Change ".concat(_this3.app.keychain.returnIdentifierByPublicKey(key, true), "'s score?"));
                case 1:
                  c = _context4.v;
                  if (!c) {
                    _context4.n = 3;
                    break;
                  }
                  new_score = sanitize(player.textContent);
                  new_score = parseInt(new_score);
                  _context4.n = 2;
                  return _this3.mod.createUpdatePlayerTransaction(_this3.league.id, key, new_score, 'score');
                case 2:
                  newtx = _context4.v;
                  _this3.app.network.propagateTransaction(newtx);
                  for (i = 0; i < _this3.league.players.length; i++) {
                    if (_this3.league.players[i].publicKey === key) {
                      _this3.league.players[i].score = new_score;
                    }
                  }
                case 3:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      });
    }
  }]);
}();
module.exports = LeagueOverlay;